import React from 'react';
import { Link } from 'react-router-dom';
import { Terminal } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="relative border-t border-cyan-500/10 mt-20" data-id="element-215">
      {/* Cyber Glow Line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent" data-id="element-216"></div>

      {/* Glass Background */}
      <div className="glass backdrop-blur-modern" data-id="element-217">
        <div className="container mx-auto px-4 py-12" data-id="element-218">
          <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-219">
            {/* Brand */}
            <div className="md:col-span-1" data-id="element-220">
              <Link to="/" className="inline-block mb-4 group max-w-full" data-id="element-221">
                <div className="text-sm sm:text-base lg:text-lg font-bold font-mono text-cyan-500 group-hover:text-cyan-400 transition-colors break-words overflow-wrap-anywhere" data-id="element-222">
                  cybersecurityprotocol.org
                </div>
              </Link>
              <p className="text-sm text-slate-400 mb-4 leading-relaxed font-sans" data-id="element-223">
                {t('footer.brand.desc')}
              </p>
              <p className="text-xs text-slate-600 italic font-sans mb-3" data-id="element-224">
                {t('footer.brand.note')}
              </p>
              <p className="text-xs text-slate-500 leading-relaxed font-sans" data-id="element-225">
                {t('footer.builtBy')}
              </p>
            </div>

            {/* Protocols */}
            <div data-id="element-226">
              <h3 className="text-sm font-bold text-slate-100 uppercase mb-4 font-mono flex items-center" data-id="element-227">
                <Terminal className="h-3 w-3 mr-2 text-cyan-500" data-id="element-228" />
                {t('footer.protocols')}
              </h3>
              <ul className="space-y-2 text-sm text-slate-400 font-sans" data-id="element-229">
                <li data-id="element-230">
                  <Link to="/personal" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-231">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-232">
                      ▸
                    </span>
                    {t('nav.personal')}
                  </Link>
                </li>
                <li data-id="element-233">
                  <Link to="/organization" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-234">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-235">
                      ▸
                    </span>
                    {t('nav.organization')}
                  </Link>
                </li>
                <li data-id="element-236">
                  <Link to="/start" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-237">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-238">
                      ▸
                    </span>
                    {t('footer.riskAssessment')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div data-id="element-239">
              <h3 className="text-sm font-bold text-slate-100 uppercase mb-4 font-mono flex items-center" data-id="element-240">
                <Terminal className="h-3 w-3 mr-2 text-cyan-500" data-id="element-241" />
                {t('footer.resources')}
              </h3>
              <ul className="space-y-2 text-sm text-slate-400 font-sans" data-id="element-242">
                <li data-id="element-243">
                  <Link to="/tools" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-244">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-245">
                      ▸
                    </span>
                    {t('footer.toolsLibrary')}
                  </Link>
                </li>
                <li data-id="element-246">
                  <Link to="/compliance/global" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-247">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-248">
                      ▸
                    </span>
                    {t('footer.complianceGuides')}
                  </Link>
                </li>
                <li data-id="element-249">
                  <Link to="/about/standards" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-250">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-251">
                      ▸
                    </span>
                    {t('footer.standardsMapping')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* About */}
            <div data-id="element-252">
              <h3 className="text-sm font-bold text-slate-100 uppercase mb-4 font-mono flex items-center" data-id="element-253">
                <Terminal className="h-3 w-3 mr-2 text-cyan-500" data-id="element-254" />
                {t('footer.about')}
              </h3>
              <ul className="space-y-2 text-sm text-slate-400 font-sans" data-id="element-255">
                <li data-id="element-256">
                  <Link to="/about/mission" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-257">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-258">
                      ▸
                    </span>
                    {t('footer.missionVision')}
                  </Link>
                </li>
                <li data-id="element-259">
                  <Link to="/about/scope" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-260">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-261">
                      ▸
                    </span>
                    {t('footer.scopeDisclaimer')}
                  </Link>
                </li>
                <li data-id="element-262">
                  <Link to="/about/contact" className="hover:text-cyan-400 transition-colors inline-flex items-center group" data-id="element-263">
                    <span className="text-cyan-500 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-264">
                      ▸
                    </span>
                    {t('footer.contact')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-cyan-500/10 pt-8 relative" data-id="element-265">
            {/* Top Glow Line */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" data-id="element-266"></div>

            <div className="text-center" data-id="element-267">
              <div className="text-xs text-slate-500 font-sans" data-id="element-268">
                <p className="text-[10px] leading-relaxed" data-id="element-269">
                  © {new Date().getFullYear()} {t('footer.copyright')}
                </p>
                <p className="text-[10px] text-slate-600 leading-relaxed" data-id="element-270">
                  {t('footer.educational')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}